export function compareById(a: any, b: any) {
    return a.id - b.id;
}

export const TableRowLimits = {
    NODES: 50,
    BRANCHES: 100,
    EQUIPMENTS: Infinity,
};


/* Используется в API! Не менять без согласования с бэкендом! */
export const TableNames = {
    NODES: "nodes",
    BRANCHES: "branches",
    EQUIPMENTS: "equipments",
};